let actions = {
  // Action called when the sign document button is clicked
  onCallDocusign: () => {}
};

export function setActions(newActions = {}) {
  for (const action in newActions) {
    actions[action] = newActions[action];
  }
}

export default actions;
